import { isNotEmptyObject } from './isNotEmptyObject';

export function buildAliases(aliases: any): any {
	if (isNotEmptyObject(aliases)) {
		return { aliases: aliases };
	}
	return undefined;
}
